import React, { Component } from 'react';
import HomeModalWrapper from './HomeModalWrapper';
import SingleLineCaption from './../../components/dom-elements/SingleLineCaption';
import BgImage from './../../components/dom-elements/BgImage';
import { widths, colors } from './../../styles/theme.json';

export default class extends Component {
  constructor(props) {
    super(props);
    this.keydown = this._handleKeyDown.bind(this);
  }
  
  _handleKeyDown(event) {
    switch ( event.keyCode ) {
      case 27:
        this.props.ClickFunction();
        break;
      default: 
        break;
    };
  };

  componentWillMount(){
    document.addEventListener('keydown', this.keydown);
  };

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keydown);
  };

  render() {
    return (
      <HomeModalWrapper>
        <div id={'popover-wrapper'}>
          <button id={'close-popover'} onClick={this.props.ClickFunction} />
          <div id={'popover-img-wrapper'}>
            <div id={'image-wrap'}>
              <BgImage source={this.props.popoverData.image.large} bgSize={'contain'}/>
            </div>
            {/*<div id={'caption-wrap'} className='pop-in'>
              <SingleLineCaption White={true} Headline={this.props.popoverData.title} Description={this.props.popoverData.description}/>
    </div>*/}
          </div>
          <style jsx>{`
            :global(#homepage-modal) {
              width: 100%;
              height: 100vh;
              position: fixed;
              top: 0;
              left: 0;
              z-index: 10000;
              background: ${colors.black};
            }
            h1 {
              color: white;
            }
            #popover-wrapper {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            #close-popover {
              position: fixed;
              top: 2.5rem;
              right: 2.5rem;
              height: 2rem;
              width: 3.5rem;
              border: 0;
              background-color: rgba(0,0,0,0);
              z-index: 12000;
              cursor: pointer;
            }
            #close-popover:after {
              position: absolute;
              top: 0;
              right: 0;
              z-index: 12001;
              content: 'CLOSE';
              color: white;
              font-weight: bold;
            }
            #caption-wrap {
              padding-top: 2rem;
              width: 100%;
              max-width: ${widths.global_max_width};
            }
            #image-wrap {
              display: flex;
              flex: 1;
              width: 100%;
              height: 100%;
            }
            #popover-img-wrapper {
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              text-align: center;
            }
          `}</style>
        </div>
      </HomeModalWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/HomeModal.js